<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :height="height ? height : '2em'"
    :width="width ? width : '2em'"
    viewBox="0 0 512 512"
  >
    <path
      d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
      :fill="color || '#e5bb61'"
    />
  </svg>
</template>
<script lang="ts" setup>
interface IProps {
  color?: string;
  width?: string;
  height?: string;
}

// eslint-disable-next-line no-undef, @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<IProps>(), {});
</script>
